import { useTheme } from '@mui/material/styles'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { FC } from 'react'
import { dateSelectStyles } from './styles'

type DateSelectProps = DatePickerProps<Date> & { fullWidth?: boolean, helperText?: string, error?: boolean }

export const DateSelect: FC<DateSelectProps> =
    ({ fullWidth, helperText, error, ...props }) => {
        const theme = useTheme()
        const classes = dateSelectStyles(theme)

        // Use slotProps to pass props to the textField component
        // This is the recommended approach in newer versions of MUI X Date Pickers
        const slotProps = {
            textField: {
                fullWidth: fullWidth || false,
                helperText,
                error,
            },
        }

        return (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker className={classes.root} slotProps={slotProps} {...props} />
            </LocalizationProvider>
        )
    }
